import { DownloadIcon } from './DownloadIcon';

/**
 * author: Google
 * id 704F7397-0E85-4213-8D76-FE156DF1795F
 * name download
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/download.svg
 * tags
 */
export const GetAppIcon = DownloadIcon;
export default GetAppIcon